import { Spinner, makeStyles } from '@fluentui/react-components';

/* Full-viewport centred spinner for whole-page gating states (session check,
   workspace load) that render before the app shell exists. position: fixed +
   inset: 0 centres it in the dead centre of the viewport regardless of parent. */

const useStyles = makeStyles({
  root: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export function FullPageSpinner({ label }: { label?: string }) {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <Spinner label={label} />
    </div>
  );
}
